import React, { useState, useEffect, useCallback, useRef } from "react";
import EntityConstants from "../../configs/EntityConstants";
import { GET, POST } from "../../service/CRUDService";
import Toast from "../../common/Toast/Toast";
import Dropdown from "../../common/Dropdown/Dropdown";
import TenantApprovalsLongCard from "../../components/Cards/TenantApprovalsLongCard/TenantApprovalsLongCard";
import { useNavigate, useLocation } from "react-router-dom";
import CfLoader from "../../common/CfLoader/CfLoader";
import "react-datepicker/dist/react-datepicker.css";
import { subDays, startOfDay, endOfDay } from "date-fns";
import DateFilterDropdown from "../../components/DateFilterDropdown/DateFilterDropdown";
// import BulkTenantApprovalModal from "../../common/BulkTenantApprovalModal/BulkTenantApprovalModal";

const SEARCH_DEBOUNCE_DELAY = 500;

const TenantApprovalPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const savedFilters = location.state?.filters || {};

  const limit = 6;
  const [respContentList, setRespContentList] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [search, setSearch] = useState(savedFilters.search || "");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(search);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [offset, setOffset] = useState(savedFilters.offset || 0);
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState(
    savedFilters.approvalStatus || null
  );

  //   COMMNENTED OUT COZ BULK APPROVAL MODAL NOT REQUIRED FOR NOW

  //   const [isModalOpen, setIsModalOpen] = useState(false);
  //   const [actionType, setActionType] = useState("");
  //   const [allSelected, setAllSelected] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [, setIssuerComments] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [dateRange, setDateRange] = useState("dateselection");
  const isProcessingRef = useRef(false);

  const formatDateForAPI = (date) => {
    if (!date) return "";
    return new Date(date).toISOString();
  };
  //     const selectedTransactionIds = useMemo(
  //     () => new Set(selectedTransactions.map(t => t.verifier_id)),
  //     [selectedTransactions]
  //   );

  const getDateRangeForAPI = () => {
    const now = new Date();
    let startDate, endDate;

    switch (dateRange) {
      case "recent":
        startDate = subDays(startOfDay(now), 6);
        endDate = endOfDay(now);
        break;
      case "last30days":
        startDate = subDays(startOfDay(now), 29);
        endDate = endOfDay(now);
        break;
      case "last3months":
        startDate = subDays(startOfDay(now), 89);
        endDate = endOfDay(now);
        break;
      case "last6months":
        startDate = subDays(startOfDay(now), 179);
        endDate = endOfDay(now);
        break;
      case "all":
        return { all_transactions: true };
      case "custom":
        if (customStartDate && customEndDate) {
          startDate = startOfDay(customStartDate);
          endDate = endOfDay(customEndDate);
        } else {
          startDate = subDays(startOfDay(now), 6);
          endDate = endOfDay(now);
        }
        break;
      default:
        startDate = subDays(startOfDay(now), 6);
        endDate = endOfDay(now);
    }

    return {
      from: formatDateForAPI(startDate),
      to: formatDateForAPI(endDate),
    };
  };

  const approvalStatusOptions = [
    { name: "Approval Status", value: null },
    { name: "Approved", value: "Approved" },
    { name: "Rejected", value: "Rejected" },
    { name: "Pending", value: "Approval Pending" },
  ];

  const updateApprovalStatus = useCallback(
    (value) => {
      if (!isInitialLoad) {
        setSelectedApprovalStatus(value);
        setOffset(0);
      }
    },
    [isInitialLoad]
  );

  //   BULK APPROVAL PART

  //   const handleCheckboxChange = (verifierId, isChecked) => {
  //     setSelectedTransactions((prevSelected) => {
  //       let newSelected;

  //       if (isChecked) {
  //         const transaction = respContentList.find(
  //           (t) => t.verifier_id === verifierId
  //         );

  //         if (!transaction) return prevSelected; // 🛡 safety

  //         newSelected = [...prevSelected, transaction];
  //       } else {
  //         newSelected = prevSelected.filter((t) => t?.verifier_id !== verifierId);
  //       }

  //       const currentPageIds = respContentList.map((t) => t.verifier_id);
  //       const selectedOnCurrentPage = newSelected.filter((t) =>
  //         currentPageIds.includes(t.verifier_id)
  //       );

  //       setAllSelected(selectedOnCurrentPage.length === respContentList.length);

  //       return newSelected;
  //     });
  //   };

  //   const updateSelectedTransactions = useCallback(
  //     (updatedTransactions) => {
  //       setSelectedTransactions(updatedTransactions);

  //       if (respContentList.length > 0) {
  //         const currentPageIds = respContentList.map((t) => t.transaction_id);
  //         const selectedOnCurrentPage = updatedTransactions.filter((t) =>
  //           currentPageIds.includes(t.transaction_id)
  //         );

  //         const allCurrentPageSelected =
  //           selectedOnCurrentPage.length === respContentList.length;
  //         setAllSelected(allCurrentPageSelected);
  //       } else {
  //         setAllSelected(false);
  //       }
  //     },
  //     [respContentList]
  //   );

  //   const handleHeaderCheckboxChange = () => {
  //     if (allSelected) {
  //       setSelectedTransactions((prev) =>
  //         prev.filter(
  //           (t) =>
  //             !respContentList.some((item) => item.verifier_id === t.verifier_id)
  //         )
  //       );
  //     } else {
  //       setSelectedTransactions((prev) => {
  //         const newSelections = respContentList.filter(
  //           (item) => !prev.some((t) => t.verifier_id === item.verifier_id)
  //         );
  //         return [...prev, ...newSelections];
  //       });
  //     }

  //     setAllSelected(!allSelected);
  //   };

  //   const handleBulkReject = () => {
  //     if (selectedTransactions.length > 0) {
  //       setActionType("Rejected");
  //       setIsModalOpen(true);
  //     }
  //   };

  //   const handleBulkAccept = () => {
  //     if (selectedTransactions.length > 0) {
  //       setActionType("Approved");
  //       setIsModalOpen(true);
  //     }
  //   };

  //   const handleConfirmAction = async (
  //     actionType,
  //     transaction_id,
  //     comment = ""
  //   ) => {
  //     if (selectedTransactions.length > 0 || transaction_id !== undefined) {
  //       const body = {
  //         transaction_id:
  //           selectedTransactions.length > 0
  //             ? selectedTransactions.map(
  //                 (transaction) => transaction.transaction_id
  //               )
  //             : transaction_id,
  //         verification_approval_status: actionType,
  //         ...(comment?.trim() && { approver_comments: comment.trim() }),
  //       };
  //       try {
  //         const response = await POST(
  //           EntityConstants.TENANT_VERIFIER_APPROVALS,
  //           body
  //         );

  //         if (response.ok) {
  //           Toast({
  //             type: "success",
  //             title: "Transaction Updated",
  //             message: `Transaction has been ${actionType.toLowerCase()} successfully!`,
  //           });

  //           setSelectedTransactions([]);
  //           setAllSelected(false);
  //           setIssuerComments("");

  //           GET_VERIFICATION_APPROVALS_LIST(limit, offset);
  //         } else {
  //           const errorData = await response.json();
  //           Toast({
  //             type: "error",
  //             title: "Error",
  //             message:
  //               errorData.message ||
  //               "An error occurred while updating the transaction.",
  //           });
  //         }
  //       } catch (error) {
  //         console.error("Error during the POST request:", error);
  //         Toast({
  //           type: "error",
  //           title: "Error",
  //           message: "An error occurred while updating the transaction status.",
  //         });
  //       }
  //     }

  //     setIsModalOpen(false);
  //   };

  const handleIndividualConfirmAction = async (
    actionType,
    verifier_id,
    comment = ""
  ) => {
    if (isProcessingRef.current) return false;
    isProcessingRef.current = true;

    if (actionType === "Rejected" && (!comment || comment.trim() === "")) {
      Toast({
        type: "error",
        title: "Validation Error",
        message: "Comments are required when rejecting a verifier request.",
      });
      isProcessingRef.current = false;
      return false;
    }

    try {
      const body = {
        verifier_id: verifier_id,
        approval_status: actionType,
        ...(comment?.trim() && { approver_comments: comment.trim() }),
      };

      const response = await POST(
        EntityConstants.TENANT_VERIFIER_APPROVALS,
        body
      );

      const data = await response.json();

      if (response.ok) {
        Toast({
          type: "success",
          title: "Success",
          message:
            data?.message ||
            `Verifier has been ${actionType.toLowerCase()} successfully!`,
        });

        GET_VERIFICATION_APPROVALS_LIST(limit, offset);

        setIssuerComments("");
        isProcessingRef.current = false;
        return true;
      }

      Toast({
        type: "error",
        title: "Error",
        message: data?.message || `API Error: ${response.status}`,
      });

      isProcessingRef.current = false;
      return false;
    } catch (error) {
      console.error("Error calling the API:", error);

      Toast({
        type: "error",
        title: "Error",
        message: "An error occurred while updating the verifier status.",
      });

      isProcessingRef.current = false;
      return false;
    }
  };

  const handleCardClick = (transaction) => {
    const currentFilters = {
      search,
      offset,
      approvalStatus: selectedApprovalStatus,
    };

    const status =
      selectedApprovalStatus ||
      transaction.approval_status ||
      "Approval Pending";

    // Just navigate with basic transaction data
    navigate(`/issuer/verifier-approvals/${transaction.org_code}`, {
      state: {
        ...transaction,
        filters: currentFilters,
        status,
      },
    });
  };

  const GET_VERIFICATION_APPROVALS_LIST = (limit, currentOffset) => {
    setIsSearching(true);
    const dateRangeParams = getDateRangeForAPI();
    let apiUrl = `${EntityConstants.TENANT_VERIFIER_APPROVALS}?limit=${limit}&offset=${currentOffset}`;

    if (dateRangeParams.all_transactions) {
      apiUrl += `&all_transactions=true`;
    } else {
      apiUrl += `&from=${encodeURIComponent(
        dateRangeParams.from
      )}&to=${encodeURIComponent(dateRangeParams.to)}`;
    }

    if (selectedApprovalStatus) {
      apiUrl += `&approval_status=${encodeURIComponent(
        selectedApprovalStatus
      )}`;
    }
    if (debouncedSearchTerm) {
      apiUrl += `&search=${encodeURIComponent(debouncedSearchTerm)}`;
    }

    const temp_array = respContentList;
    setRespContentList([]);

    GET(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          Toast({
            type: "error",
            title: "Error",
            message: data.error,
          });
          setRespContentList(temp_array);
        } else {
          setRespContentList(data.results);
          setPrevious(data.previous);
          setNext(data.next);

          const currentPageIds = data.results.map((t) => t.verifier_id);
          const filteredSelections = selectedTransactions.filter((t) =>
            currentPageIds.includes(t.verifier_id)
          );

          setSelectedTransactions(filteredSelections);

          //   BULK APPROVAL LOGIC

          //   if (data.results.length > 0) {
          //     const allCurrentPageSelected =
          //       filteredSelections.length === data.results.length;
          //     setAllSelected(allCurrentPageSelected);
          //   }
          //    else {
          //     setAllSelected(false);
          //   }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsSearching(false);
        setIsSearched(true);
      });
  };

  //   BULK APPROVAL LOGIC

  //   const refreshTable = useCallback(() => {
  //     GET_VERIFICATION_APPROVALS_LIST(limit, offset);
  //   }, [limit, offset, GET_VERIFICATION_APPROVALS_LIST]);

  useEffect(() => {
    const savedFilters = location.state?.filters || {};
    if (savedFilters.approvalStatus) {
      setSelectedApprovalStatus(savedFilters.approvalStatus);
    }
    if (savedFilters.offset) {
      const savedOffset = parseInt(savedFilters.offset);
      if (!isNaN(savedOffset) && savedOffset >= 0) {
        setOffset(savedOffset);
      }
    }
  }, [location.state]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(search);
    }, SEARCH_DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    GET_VERIFICATION_APPROVALS_LIST(limit, offset);

    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  }, [
    debouncedSearchTerm,
    selectedApprovalStatus,
    limit,
    offset,
    dateRange,
    customStartDate,
    customEndDate,
  ]);

  const handlePrevious = () => {
    setOffset(offset - limit);
  };

  const handleNext = () => {
    setOffset(offset + limit);
  };

  return (
    <div className="flex flex-col items-center w-full mt-20 bg-cfSecondary min-h-screen">
      <div
        className={`w-full bg-cfSearchContainer flex justify-center py-[0.8rem] px-4`}
      >
        <div
          className={`flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-2 sm:gap-0`}
        >
          <p className="text-cfHeadingText font-semibold self-start my-auto">
            Verifier Approvals
          </p>
          <form
            onSubmit={(e) => e.preventDefault()}
            className=" bg-cfSecondary p-2 rounded-lg w-full sm:w-[25rem] self-center ml-[0rem] md:ml-[0.630rem] md:self-end md:m-0"
          >
            <input
              type="text"
              name="search"
              id="search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value.toLowerCase());
                setOffset(0);
              }}
              placeholder="Search for organization"
              className="outline-none border-none p-0 placeholder:text-sm w-full"
              style={{ fontSize: "0.875rem", lineHeight: "1.25rem" }}
            />
          </form>
        </div>
      </div>

      <div className="flex md:flex-wrap items-center gap-4 justify-start mx-[1rem] mt-[0.6rem] mb-[-0.6rem] w-full">
        <div className="flex flex-col md:flex-row w-full items-start md:items-center md:justify-between gap-4 px-4 md:px-8">
          <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto md:items-center">
            <div className="flex md:items-center">
              <DateFilterDropdown
                dateRange={dateRange}
                setDateRange={setDateRange}
                customStartDate={customStartDate}
                setCustomStartDate={setCustomStartDate}
                customEndDate={customEndDate}
                setCustomEndDate={setCustomEndDate}
              />
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto md:flex-nowrap md:overflow-visible">
              <div className="w-full md:w-[200px]">
                <Dropdown
                  options={approvalStatusOptions}
                  selected={
                    approvalStatusOptions.find(
                      (option) => option.value === selectedApprovalStatus
                    ) || approvalStatusOptions[0]
                  }
                  onSelect={updateApprovalStatus}
                  buttonClass="px-4 py-2 border rounded-md w-full"
                  menuClass="z-20 w-full"
                />
              </div>
            </div>
          </div>

          {/* BULK APPROVAL LOGIC*/}

          {/* <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto justify-end md:justify-start md:items-center md:shrink-0">
            {selectedTransactions.length > 0 &&
              selectedApprovalStatus !== "Approved" &&
              selectedApprovalStatus !== "Rejected" && (
                <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto md:flex-nowrap">
                  <button
                    className="flex rounded-[8px] items-center justify-center gap-2 w-full px-4 py-2 bg-cfPrimaryButton text-white font-semibold text-md hover:bg-cfPrimaryDark transition duration-200 focus:outline-none"
                    onClick={handleBulkAccept}
                  >
                    Approve
                  </button>

                  <button
                    className="flex rounded-[8px] items-center justify-center gap-2 w-full px-4 py-2 bg-white text-black font-semibold text-md border border-gray-800 hover:bg-gray-100 transition duration-200 focus:outline-none"
                    onClick={handleBulkReject}
                  >
                    Reject
                  </button>
                </div>
              )}
          </div> */}
        </div>

        {/* <BulkTenantApprovalModal
          isModalOpen={isModalOpen}
          toggleModal={setIsModalOpen}
          actionType={actionType}
          handleConfirmAction={
            () => handleConfirmAction(actionType, undefined, issuerComments) // Use the new function
          }
          selectedTransactions={selectedTransactions}
          issuerComments={issuerComments}
          setIssuerComments={setIssuerComments}
          refreshTable={refreshTable}
          updateSelectedTransactions={updateSelectedTransactions}
        /> */}
      </div>

      <div className="overflow-x-auto w-full px-4 md:px-8 mt-[-0.2rem]">
        <div className="flex flex-col justify-center gap-2 min-w-[73.5rem] md:w-full">
          <div className="flex bg-[#E0EAFF] items-center min-h-[5rem] border py-4 px-6 mt-6 ml-[0.05rem] mr-[0.05rem]">
            {/* BULK APPROVAL LOGIC */}

            {/* <div className="flex w-[2.0%] justify-center items-center">
              {selectedApprovalStatus !== "Approved" &&
                selectedApprovalStatus !== "Rejected" && (
                  <input
                    type="checkbox"
                    checked={allSelected}
                    // onChange={handleHeaderCheckboxChange}
                    className="cursor-pointer rounded-lg"
                  />
                )}
            </div> */}

            <div className="flex w-[16.66%] justify-center items-center text-cfTableHeaderText font-bold text-[14px]">
              Verifier Name
            </div>
            <div className="flex w-[16.66%] justify-center text-cfTableHeaderText font-bold text-[14px]">
              Organization
            </div>
            <div className="flex w-[16.66%] justify-center text-cfTableHeaderText font-bold text-[14px]">
              Requested At
            </div>
            <div className="flex w-[16.66%] justify-center text-cfTableHeaderText font-bold text-[14px]">
              Email
            </div>
            <div className="flex w-[16.66%] justify-center text-cfTableHeaderText font-bold text-[14px]">
              Phone
            </div>
            <div className="flex w-[16.66%] justify-center text-cfTableHeaderText font-bold text-[14px]">
              Actions
            </div>
          </div>

          {isSearching && <CfLoader />}
          {!isSearching &&
            isSearched &&
            respContentList.length > 0 &&
            respContentList.map((transaction) => (
              <TenantApprovalsLongCard
                key={transaction.verifier_id}
                {...transaction}
                // onCheckboxChange={handleCheckboxChange}
                // isChecked={selectedTransactionIds.has(transaction.verifier_id)}

                handleConfirmAction={handleIndividualConfirmAction}
                selectedTransactions={selectedTransactions}
                // onRemoveTransaction={handleRemoveTransaction}
                onClick={() => handleCardClick(transaction)}
                selectedApprovalStatus={selectedApprovalStatus}
              />
            ))}
          {!isSearching && isSearched && respContentList.length === 0 && (
            <p className="text-center p-4 font-semibold">No results found</p>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between mt-6 px-8 w-full">
        <button
          onClick={handlePrevious}
          className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
          disabled={previous === null}
        >
          <span className="flex items-center justify-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
              />
            </svg>

            <span>previous</span>
          </span>
        </button>

        <button
          onClick={handleNext}
          className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
          disabled={next === null}
        >
          <span className="flex items-center justify-center gap-2">
            <span>Next</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
};

export default TenantApprovalPage;
